// import { addResizeListener, removeResizeListener } from 'element-ui/src/utils/resize-event'
import _ from 'lodash'

// 设置表格高度
const doResize = async(el, binding, vnode) => {
  // 获取Dom对象
  const { componentInstance: $echarts } = await vnode
  
  if (!$echarts) {
    throw new Error(`$echarts must live`)
  }

  if (!$echarts) return

  $echarts.resizeCharts()
}

export default {
  // 初始化设置
  bind(el, binding, vnode) {
    const { value } = binding
    const timeDebounce = value?.timeDebounce || 100
    // 设置resize监听方法
    el.resizeListener = _.debounce(async () => {
      await doResize(el, binding, vnode)
    }, timeDebounce)

    // 绑定监听方法到addResizeListener
    // addResizeListener(window.document.body, el.resizeListener)
    window.addEventListener('resize', el.resizeListener)
  },
  // 绑定默认高度
  async inserted(el, binding, vnode) {
    await doResize(el, binding, vnode)
  },
  // 销毁时设置
  unbind(el) {
    // 移除resize监听
    // removeResizeListener(el, el.resizeListener)
    window.removeEventListener('resize', el.resizeListener)
  }
}
